/* TrubliFit homepage: fit finder + quick add. No dependencies. */
(function () {
  if (window.__tfHome) return;
  window.__tfHome = true;

  /* ---------- Fit finder ---------- */
  function initFit(root) {
    var tabs = root.querySelectorAll('[data-tf-group]');
    var models = root.querySelectorAll('[data-tf-model]');
    var panels = root.querySelectorAll('[data-tf-panel]');

    function show(panelId) {
      panels.forEach(function (p) { p.hidden = p.getAttribute('data-tf-panel') !== panelId; });
    }
    function selectGroup(g) {
      tabs.forEach(function (t) { t.setAttribute('aria-selected', t.getAttribute('data-tf-group') === g ? 'true' : 'false'); });
      models.forEach(function (m) {
        m.hidden = m.getAttribute('data-group') !== g;
        m.setAttribute('aria-pressed', 'false');
      });
      show('default-' + g);
      var visible = [].filter.call(models, function (m) { return !m.hidden; });
      if (visible.length === 1) visible[0].click();
    }
    tabs.forEach(function (t) {
      t.addEventListener('click', function () { selectGroup(t.getAttribute('data-tf-group')); });
    });
    models.forEach(function (m) {
      m.addEventListener('click', function () {
        models.forEach(function (x) { x.setAttribute('aria-pressed', x === m ? 'true' : 'false'); });
        var id = m.getAttribute('data-tf-model');
        show(id);
        try { history.replaceState(null, '', '#fit-' + m.getAttribute('data-slug')); } catch (e) {}
        var panel = root.querySelector('[data-tf-panel="' + id + '"]');
        if (panel && window.innerWidth < 990) {
          var top = panel.getBoundingClientRect().top;
          if (top > window.innerHeight * 0.75) panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
    /* Deep link: /#fit-original-bike-plus */
    var hash = location.hash.replace('#fit-', '');
    if (hash && hash !== location.hash) {
      var target = root.querySelector('[data-slug="' + hash + '"]');
      if (target) { selectGroup(target.getAttribute('data-group')); target.click(); }
    }
  }
  document.querySelectorAll('[data-tf-fit]').forEach(initFit);

  /* ---------- Lazy, muted spotlight video ---------- */
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var saveData = navigator.connection && navigator.connection.saveData;
  document.querySelectorAll('[data-tf-video]').forEach(function (box) {
    var v = box.querySelector('video'), btn = box.querySelector('[data-tf-vid-btn]');
    var userPaused = !!(reduce || saveData), loaded = false;
    function setBtn() {
      var paused = v.paused;
      box.classList.toggle('is-paused', paused);
      btn.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
    }
    var hls = box.getAttribute('data-hls'), mp4 = box.getAttribute('data-mp4');
    var canHls = hls && v.canPlayType('application/vnd.apple.mpegurl');
    /* Phones only autoplay with adaptive streaming; otherwise they tap to play (saves data). */
    if (!canHls && window.innerWidth < 750) userPaused = true;
    function load() {
      if (loaded) return; loaded = true;
      v.src = canHls ? hls : mp4;
    }
    function play() { load(); var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    /* Some browsers claim HLS support but fail; fall back to mp4 (tap to play on phones). */
    v.addEventListener('error', function () {
      if (!canHls || !mp4) return;
      canHls = false; loaded = false;
      if (window.innerWidth < 750) { userPaused = true; v.removeAttribute('src'); v.load(); setBtn(); }
      else if (!userPaused) play();
    });
    v.addEventListener('play', setBtn); v.addEventListener('pause', setBtn);
    btn.addEventListener('click', function () {
      if (v.paused) { userPaused = false; play(); } else { userPaused = true; v.pause(); }
    });
    setBtn();
    if (!('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting && !userPaused) play();
        else if (!e.isIntersecting && !v.paused) v.pause();
      });
    }, { threshold: 0.35 }).observe(box);
  });

  /* ---------- Quick add ---------- */
  var toast, tEl = document.querySelector('[data-tf-threshold]');
  var threshold = (tEl && parseInt(tEl.getAttribute('data-tf-threshold'), 10)) || 7500;

  function money(cents) { return '$' + (cents / 100).toFixed(2).replace(/\.00$/, ''); }

  function getToast() {
    if (toast) return toast;
    toast = document.createElement('div');
    toast.className = 'tf tf-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.innerHTML = '<div><strong data-t></strong> is in your cart.</div>' +
      '<button class="tf-toast__close" type="button" aria-label="Close">&times;</button>' +
      '<div class="tf-toast__ship" data-s></div><div class="tf-toast__bar"><span data-b></span></div>' +
      '<div><a href="/cart">View cart</a></div><a class="tf-btn tf-btn--sm" style="width:auto" href="/checkout">Checkout</a>';
    toast.querySelector('.tf-toast__close').addEventListener('click', function () { toast.classList.remove('is-on'); });
    document.body.appendChild(toast);
    return toast;
  }

  function refreshBubble() {
    var bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;
    fetch('/?sections=cart-icon-bubble').then(function (r) { return r.json(); }).then(function (j) {
      var doc = new DOMParser().parseFromString(j['cart-icon-bubble'], 'text/html');
      var inner = doc.querySelector('.shopify-section');
      if (inner) bubble.innerHTML = inner.innerHTML;
    }).catch(function () {});
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-tf-add]');
    if (!form || !window.fetch) return;
    e.preventDefault();
    var btn = form.querySelector('button');
    var label = btn.textContent;
    btn.disabled = true; btn.textContent = 'Adding...';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        var t = getToast();
        t.querySelector('[data-t]').textContent = btn.getAttribute('data-title') || 'Item';
        var left = threshold - cart.total_price;
        t.querySelector('[data-s]').textContent = left > 0
          ? 'Add ' + money(left) + ' more for free shipping.'
          : 'Your order ships free.';
        t.querySelector('[data-b]').style.width = Math.min(100, cart.total_price / threshold * 100) + '%';
        t.classList.add('is-on');
        clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('is-on'); }, 7000);
        btn.textContent = 'Added';
        setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1800);
        refreshBubble();
      })
      .catch(function () { form.submit(); });
  });
})();
